<template>
  <div>
    <v-menu
      content-class="user-instances-tooltip"
      open-delay="150"
      close-delay="150"
      v-model="opened"
      :disabled="!instances_count"
      open-on-hover
      offset-x
      :right="!left"
      :left="left"
      :nudge-right="left ? '-12px' : '12px'"
      max-height="445"
      min-width="460"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <slot />
        </div>
      </template>
      <v-card elevation="4" width="460">
        <v-card-title class="px-5 py-4">
          <h5 class="user-instances-tooltip__title">{{ $t("reseller.user.sharedInstances") }}</h5>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="d-flex flex-column p-0">
          <template v-if="!fetching">
            <router-link
              :to="`/instances/${item.id}`"
              class="d-flex align-center instance"
              v-for="(item, index) in instances"
              :key="item.id + '-' + index"
            >
                <InstanceAvatar :instance="item" :size="40" :ssl="true" />
                <div class="d-flex flex-column instance__content flex-grow-1">
                    <p class="d-flex align-center p-lg">
                    {{ item.title }}
                    <v-tooltip
                        v-if="item.service_status === 'suspended'"
                        transition="custom-tooltip"
                        open-delay="150"
                        bottom
                        z-index="99"
                        offset-overflow
                        nudge-bottom="12px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <div class="suspend-chip ml-2" v-on="on" v-bind="attrs">
                            <v-icon color="sand darken-2" size="12" class="mr-1">
                            $suspended
                            </v-icon>
                            {{ $t("message.status.suspended") }}
                        </div>
                        </template>
                        <div class="d-flex align-center">
                        <v-icon color="sand darken-2" size="16"
                            >$suspended</v-icon
                        >
                        <span class="sand--text text--darken-2 ml-1">
                            {{ $t("tooltip.hosting.service.suspended") }}
                        </span>
                        </div>
                    </v-tooltip>
                    <statusIndicator :sameSize="true" :instance="item"/>
                   </p>
                    <a
                    class="instance__link"
                    @click="$event.stopPropagation()"
                    :href="item.url"
                    >{{ item.url }}</a
                    >
                </div>
                <div class="instance__created p-sm" v-if="item.created_at">
                    <span>{{ $t("reseller.user.created") }}:</span>
                    <span class="font-weight-bold">{{ new Date(item.created_at).toLocaleDateString('gb-GB') }}</span>
                </div>
            </router-link>
          </template>
          <template v-else>
            <div v-for="item in 5" :key="item" class="d-flex py-2 px-6">
              <v-skeleton-loader type="avatar" class="my-1" />

              <div class="d-flex flex-column ml-4">
                <v-skeleton-loader
                  type="text"
                  height="16"
                  width="140"
                  class="mb-1"
                />
                <v-skeleton-loader type="text" height="14" width="80" />
              </div>
            </div>
          </template>          
        </v-card-text>
        <v-divider></v-divider>
        <div class="user-instances-tooltip__footer">
            <v-btn
              text
              color="primary"
              outlined
              :to="`/instances`"
              class="py-0 px-3"
            >
            {{ $t("reseller.user.fullList") }}
            <v-icon :size="16" color="primary" class="mr-0">$fillArrowRight</v-icon>
            </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>


<style lang="scss">
    .user-instances-tooltip{
        overflow: hidden !important;
        &__title{
            font-size: 16px;
            font-weight: 700;
            line-height: 26px;
        }
        .v-card__text {
            padding: 8px;
            max-height: 240px;
            overflow-y: auto;
        }
        .v-card__actions {
            padding: 16px;
        }
        .instance{
            padding: 8px 16px;
            gap: 16px;
            transition: background-color 0.2s ease;
            &:hover {
                background-color: map-get($gray, lighten5);
            }
            p{
                gap: 8px;
                margin-bottom: 0;
                font-weight: 700;
                color:var(--v-text-darken2)
            }
            .status-indicator-container{
                min-height: unset;
            }
            &__link{
                color: map-get($gray, darken1);
            }
            &__created{
                display: flex;
                flex-direction: column;
                text-align: right;
                color: map-get($gray, darken1);
            }
        }
        .user-instances-tooltip__footer{
            display: flex;
            padding: 16px 24px;
            gap: 16px;
        }
    }
</style>
<script>
import Api from "../../apis/Api";
import InstanceAvatar from "../../components/InstanceAvatar.vue";
import StatusIndicator from "../../components/instances/StatusIndicator.vue";
export default {
  components: {
    InstanceAvatar,
    StatusIndicator,
  },
  props: {
    user: Object,
    instances_count: Number,
    left: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: false,
      fetching: false,
      instances: [],
      showArchived: false,
    };
  },
  computed: {},
  mounted() {
    this.fetchInstances();
  },
  methods: {
    async fetchInstances() {
      this.fetching = true;
      Api.get(`/reseller/users/${this.user.id}/instances`)
        .then((response) => {
          this.instances = response.data.data.map((instance) => {
            return Api.instances().instanceResource(instance);
          });
        })
        .catch((error) => {
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
